import { useConnectModal } from '@rainbow-me/rainbowkit'
import {
  Zapper,
  ZapperProps,
  PROVIDER_ENABLED,
} from '@reserve-protocol/react-zapper'
import { bsc } from 'viem/chains'
import { useAccount } from 'wagmi'
import { useAtomValue } from 'jotai'
import { localeAtom } from '@/i18n'
import LargeMintPrompt from './large-mint-prompt'

const bscProviders = PROVIDER_ENABLED[bsc.id]
if (bscProviders) {
  bscProviders.odos = false
}

type ZapperWrapperProps = ZapperProps

const ZapperWithConnect = (props: ZapperProps) => {
  const { openConnectModal } = useConnectModal()
  return <Zapper {...props} connectWallet={openConnectModal} />
}

const ZapperWrapper = (props: ZapperWrapperProps) => {
  const { isConnected } = useAccount()
  // Drive the widget's language from the app locale. The zapper only ships
  // en/es/ko/zh, so the dev-only `pseudo` locale falls back to English.
  const appLocale = useAtomValue(localeAtom)
  const locale = appLocale === 'pseudo' ? 'en' : appLocale

  // The inline prompt is positioned `absolute` and anchors to the consumer's
  // nearest positioned ancestor (the issuance page wraps the zapper card in a
  // `relative` div whose right edge is the card's outer edge), so we don't add
  // our own relative wrapper here — that would anchor it inside the card padding
  // and overlap the card.
  return (
    <>
      {!isConnected ? (
        <ZapperWithConnect {...props} locale={locale} />
      ) : (
        <Zapper {...props} locale={locale} />
      )}
      <LargeMintPrompt
        mode={props.mode ?? 'modal'}
        dtfAddress={props.dtfAddress}
        chain={props.chain}
      />
    </>
  )
}

export default ZapperWrapper
